import React, { useEffect, useState } from 'react';
import { PageHeader, PageLoader } from '@/components/common/Layout';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { api } from '@/lib/api';

export default function AdminConfigPage() {
  const [items, setItems] = useState(null);
  const [key, setKey] = useState('detection.min_area_pct');
  const [val, setVal] = useState('0.5');

  const load = () => api.get('/admin/config').then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      let value = val;
      try { value = JSON.parse(val); } catch { value = { value: val }; }
      await api.post('/admin/config', { key, value: (typeof value === 'object' ? value : { value }) });
      toast.success('Configuration saved');
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Save failed'); }
  };

  return (
    <div className="p-6 max-w-[1200px] mx-auto">
      <PageHeader title="Configuration" subtitle="Thresholds, escalation rules and organisation preferences." />
      <div className="grid lg:grid-cols-2 gap-4">
        <Card className="p-4">
          <div className="text-sm font-semibold">Set configuration key</div>
          <div className="mt-3 space-y-3">
            <div><Label>Key</Label><Input value={key} onChange={e => setKey(e.target.value)} data-testid="config-key" /></div>
            <div><Label>Value (JSON or string)</Label><Input value={val} onChange={e => setVal(e.target.value)} data-testid="config-val" /></div>
            <Button onClick={save} data-testid="config-save">Save</Button>
          </div>
          <div className="mt-4 text-xs text-muted-foreground">
            Examples: <span className="font-mono">alert.escalation_hours = 24</span>,
            <span className="font-mono"> retention.audit_days = 365</span>
          </div>
        </Card>
        <Card className="p-4">
          <div className="text-sm font-semibold">Current configuration</div>
          {!items ? <PageLoader /> :
            <div className="mt-3 divide-y divide-border">
              {items.length === 0 ? <div className="text-sm text-muted-foreground">None yet</div> :
                items.map(c => (
                  <div key={c.id} className="py-2 text-xs">
                    <div className="font-mono">{c.key}</div>
                    <div className="text-muted-foreground mt-0.5">{JSON.stringify(c.value)}</div>
                  </div>
                ))}
            </div>}
        </Card>
      </div>
    </div>
  );
}
